export default __webpack_public_path__ + "static/media/Pretendard-SemiBold.subset.d27c10f7.woff2";